import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { TransportEndpoint } from '../../constants/transport-endpoint';
import { TransportCatalogSearchCriteria } from '../../models/transport.model';
import { TransportOrderCatalogStateModel } from '../catalog/transport-order-catalog.state';
import { convertDateRangesToWallClockUTC } from '../../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class TransportOrderCatalogService {
  constructor(private http: WrapperHttpService) {}

  getTransportOrderCatalog({
    size,
    page,
    ...filter
  }: Partial<TransportCatalogSearchCriteria>): Observable<TransportOrderCatalogStateModel> {
    const url = `${API_URL}${TransportEndpoint.Base}${TransportEndpoint.TransportOrders}`;
    return this.http
      .withLoading()
      .post<TransportOrderCatalogStateModel>(url, { size, page, filter: convertDateRangesToWallClockUTC(filter) });
  }
}
